import React, {Component, Fragment} from 'react';
import {renderToStaticMarkup} from 'react-dom/server';
import {withLocalize} from 'react-localize-redux';
import {BrowserRouter} from 'react-router-dom';
import {LastLocationProvider} from 'react-router-last-location';
import Router from './router/Router';
import Header from '../features/Layout/components/Header';
import Footer from '../features/Layout/components/Footer';
import CustomLayout from '../features/Layout/components/CustomLayout';
import translationsRoutes from './router/translations_routes';
import ScrollToTop from './router/ScrollToTop';

class Main extends Component {
    constructor(props) {
        super(props);

        const languages = [
            {name: "Français", code: "fr"},
            {name: "English", code: "en"},
        ];

        const currentUri = window.location.pathname;
        let defaultLanguage = localStorage.getItem('languageCode') || languages[0].code;
        let uriLanguage = '';

        // Automatically changed the default language if the URI start with a lang code (for ex. /en/)
        languages.forEach(function (language) {
            if (currentUri.startsWith('/' + language.code + '/')) {
                uriLanguage = language.code;
            }
        });

        if (uriLanguage !== '') {
            if (defaultLanguage !== uriLanguage) {
                defaultLanguage = uriLanguage;
            }
        }

        this.props.initialize({
            languages: languages,
            translation: translationsRoutes, // Global translations
            options: {
                renderToStaticMarkup,
                renderInnerHtml: true,
                defaultLanguage: defaultLanguage
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const prevLangCode = prevProps.activeLanguage && prevProps.activeLanguage.code;
        const currentLangCode = this.props.activeLanguage && this.props.activeLanguage.code;
        const hasLanguageChanged = prevLangCode !== currentLangCode;

        if (hasLanguageChanged) {
            // Persist the active language
            localStorage.setItem('languageCode', currentLangCode);
        }
    }

    render() {
        return (
            <BrowserRouter>
                <LastLocationProvider>
                    <ScrollToTop>
                        <Header/>
                        <main>
                            <Router/>
                        </main>
                        <Footer/>
                        <CustomLayout/>
                    </ScrollToTop>
                </LastLocationProvider>
            </BrowserRouter>
        );
    }
}

export default withLocalize(Main);


// WEBPACK FOOTER //
// ./src/app/Main.js